/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const settingsRoutes = {
  path: '/settings',
  component: Layout,
  redirect: '/settings',
  name: 'Settings',
  alwaysShow: true,
  meta: {
    title: 'settings',
    icon: 'Tools',
    permissions: ['update_pos_view', 'office_info_view', 'print_paper_size_view', 'entry_pin_view', 'country_view', 'state_view', 'district_view', 'city_view'],
  },
  children: [
    /** Settings managements */
    {
      path: 'pos-settings/update/1',
      component: () => import('@/views/pos-setting/Update'),
      name: 'PosSettingUpdate',
      meta: { title: 'Update Pos Setting', icon: 'edit', permissions: ['update_pos_view'] },
    },
    {
      path: 'office-info/update/1',
      component: () => import('@/views/office-info/Update'),
      name: 'OfficeInfoUpdate',
      meta: { title: 'Office Info Update', icon: 'edit', permissions: ['office_info_view'] },
    },
    {
      path: 'print-paper-size',
      component: () => import('@/views/print-paper-size/List'),
      name: 'PaperPrintList',
      meta: { title: 'Print Paper Size', icon: 'edit', permissions: ['print_paper_size_view'] },
    },
    {
      path: 'entry-pin/update/1',
      component: () => import('@/views/entry-pin/Update'),
      name: 'entryPinUpdate',
      meta: { title: 'entryPinUpdate', icon: 'edit', permissions: ['entry_pin_view'] },
    },
    {
      path: 'milestone/view/:id(\\d+)',
      component: () => import('@/views/milestone/View'),
      name: 'viewMilestone',
      meta: { title: 'View Milestone', icon: 'edit', noCache: true },
      hidden: true,
    },
    {
      path: 'country/list',
      component: () => import('@/views/country/List'),
      name: 'countryList',
      meta: { title: 'countryList', icon: 'Memo', permissions: ['country_view'] },
    },
    {
      path: 'state/list',
      component: () => import('@/views/state/List'),
      name: 'stateList',
      meta: { title: 'stateList', icon: 'Memo', permissions: ['state_view'] },
    },
    {
      path: 'district/list',
      component: () => import('@/views/district/List'),
      name: 'districtList',
      meta: { title: 'districtList', icon: 'Memo', permissions: ['district_view'] },
    },
    {
      path: 'city/list',
      component: () => import('@/views/city/List'),
      name: 'cityList',
      meta: { title: 'cityList', icon: 'Memo', permissions: ['city_view'] },
    },
  ],
};

export default settingsRoutes;
